// Structured data schemas for SEO (Schema.org JSON-LD)

const BASE_URL = "https://whitefieldlegalservices.com";

/**
 * LegalService schema with full business details.
 * Used on the homepage for rich search results.
 */
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LegalService",
  name: "Whitefield Legal Services",
  description:
    "Expert property searches for conveyancers, estate agents, and auction houses. 7-10 day guaranteed turnaround vs 142+ day industry average. Reduce fall-throughs, accelerate transactions.",
  url: BASE_URL,
  telephone: "+44-1923-620240",
  email: "admin@whitefieldlegal.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "2nd Floor Argyle House, Joel Street",
    addressLocality: "Northwood Hills",
    postalCode: "HA6 1NW",
    addressCountry: "GB",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "51.6094",
    longitude: "-0.4044",
  },
  openingHours: ["Mo-Fr 09:00-17:30", "Sa 09:00-13:00"],
  sameAs: [BASE_URL],
  areaServed: {
    "@type": "Country",
    name: "United Kingdom",
  },
  serviceType: [
    "Conveyancing Searches",
    "Estate Agent Property Searches",
    "Auction House Search Services",
    "Local Authority Searches",
    "Environmental Searches",
    "Water & Drainage Reports",
    "Upfront Search Packs",
    "Property Transaction Acceleration",
    "Property Legal Services",
  ],
  foundingDate: "2003",
  hasCredential: [
    {
      "@type": "EducationalOccupationalCredential",
      name: "IPSA Membership",
      credentialCategory: "Professional Membership",
    },
    {
      "@type": "EducationalOccupationalCredential",
      name: "PCCB Registration",
      credentialCategory: "Professional Registration",
    },
  ],
};

/**
 * WebSite schema for sitewide search-engine understanding.
 */
export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Whitefield Legal Services",
  url: BASE_URL,
  description:
    "Expert property searches for conveyancers, estate agents, and auction houses across the United Kingdom.",
  inLanguage: "en-GB",
};

/**
 * Builds a BreadcrumbList schema from an array of breadcrumb items.
 * The last item has no URL (current page).
 */
export function buildBreadcrumbs(
  crumbs: { name: string; path?: string }[]
) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      ...(crumb.path ? { item: `${BASE_URL}${crumb.path}` } : {}),
    })),
  };
}
